import { Timestamp } from "firebase/firestore";
import { useContext, useEffect, useState } from "react";
import { DefaultContext } from "../../../contexts/default";
import InsumosExitDB from "../../../database/wrappers/insumosExit";
import PreAlert from "../../../helpers/utils/preAlert";
import api from "../../../services/api";
import BtnLoad from "../../MyCustom/BtnLoad";
import Button from "../../bootstrap/Button";
import { CardBody } from "../../bootstrap/Card";
import Modal, { ModalBody, ModalHeader, ModalTitle } from "../../bootstrap/Modal";
import FormGroup from "../../bootstrap/forms/FormGroup";
import Input from "../../bootstrap/forms/Input";
import { convertGramaToKg, dividePerMlOrKgCMV, getFloatCMV, MultiplierPerMlOrKgCMV } from "../../../utils/cmv/convertQtd";
import Spinner from "../../bootstrap/Spinner";
import { increment } from 'firebase/firestore';
import InsumosStoreDB from "../../../database/wrappers/insumosStore";

const ModalSaidaInsumo = ({ open, handleOpen }) => {
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [search, setSearch] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
    const { estabSelected, storeSelected, onShowAlert, user } = useContext(DefaultContext);


    useEffect(() => {
        if (open) {
            setisLoading(true);
            setRows([]);
            setSearch("")
            api.post('routes/insumeDay', {
                estab: estabSelected,
                store: storeSelected,
                date: selectedDate
            }).then((response) => {
                setRows(response.data);
            }).catch((error) => {
                console.log('Erro ao buscar insumos', error);
                onShowAlert(PreAlert.error('Erro ao buscar os dados para esta data.'));
            }).finally(() => {
                setisLoading(false);
            });
        }
    }, [open, selectedDate, estabSelected, storeSelected]);

    useEffect(() => {
        const query = search.toLowerCase();
        const filtered = rows.filter(r =>
            r.name.toLowerCase().includes(query)
        );
        setFilteredRows(filtered);
    }, [search, rows]);

    const onSucess = async () => {
        const allInsumos = await new InsumosStoreDB(estabSelected, storeSelected).getAll();
        setisLoading(true);
        const array = rows.map((r) => ({
            insumeId: r.id,
            name: r.name,
            qtd: dividePerMlOrKgCMV(r?.newQtd, r.unit),
            qtdLoss: dividePerMlOrKgCMV(r?.newLoss, r.unit),
            qtdPromotial: dividePerMlOrKgCMV(r?.newPromotial, r.unit),
            unit: r.unit,
            price: allInsumos.find(insumo => insumo.id === r.id)?.price ?? 0
        })).filter((item) => item.qtd !== 0 || item.qtdLoss !== 0 || item.qtdPromotial !== 0);

        if (array.length === 0) {
            handleOpen(false);
            setRows([]);
            return;
        }

        const [year, month, day] = selectedDate.split('-').map(Number);
        const dateObject = new Date(year, month - 1, day, 12, 0, 0);

        const data = {
            operator: user.displayName,
            userId: user.uid,
            insumes: array,
            created_at: Timestamp.fromDate(dateObject),
        };

        await new InsumosExitDB(estabSelected, storeSelected).createCustom(data)
            .then(() =>
                onShowAlert(PreAlert.success('Registro cadastrado com sucesso'))
            )
            .catch((e) => {
                console.log('erro writeBatch', e);
                onShowAlert(PreAlert.error('Error ao cadastrar'));
            }).finally(() => {
                handleOpen(false);
                setRows([]);
            });

        const updateStock = rows.map((r) => {
            const qtd = dividePerMlOrKgCMV(r?.newQtd, r.unit);
            const qtdLoss = dividePerMlOrKgCMV(r?.newLoss, r.unit);
            const qtdPromotial = dividePerMlOrKgCMV(r?.newPromotial, r.unit)
            const totalDecrement = (qtd + qtdLoss + qtdPromotial) - Number(r?.qtdExitAutomatic ?? 0);
            return {
                id: r.id,
                qtd: totalDecrement,
            };
        });

        await Promise.all(updateStock.map(item =>
            new InsumosStoreDB(estabSelected, storeSelected).update(item.id, { qtd: increment(-item.qtd) })
        ));

        setisLoading(false);
    };

    const handleInsumeQtds = (row, value) => {
        row.newQtd = value;
        setRows(rows.slice());
    };

    const handleInsumeLoss = (row, value) => {
        row.newLoss = value;
        setRows(rows.slice());
    };

    const handleInsumePromotial = (row, value) => {
        row.newPromotial = value;
        setRows(rows.slice());
    };

    return (
        <Modal
            isOpen={open}
            setIsOpen={handleOpen}
            isStaticBackdrop
            isScrollable={false}
            isCentered
            size="lg"
            isAnimation
            onSubmit={() => { }}
        >
            <ModalHeader className="p-4 mt-2 justify-content-start" setIsOpen={handleOpen}>
                <ModalTitle>{"Saída de insumos"}</ModalTitle>
            </ModalHeader>
            <ModalBody className="p-0">
                <CardBody>
                    <div className="row">
                        <FormGroup id="exitDate" label="Data da Saída" className='col-md-4 mb-4'>
                            <Input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup id="search" label="Pesquisar Insumo" className='col-md-6 mb-4'>
                            <Input
                                type="text"
                                placeholder="Digite o nome do insumo..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </FormGroup>
                    </div>

                    {isLoading ? (
                        <div className='d-flex flex-column justify-content-center align-items-center h-100' style={{ minHeight: '300px' }}>
                            <Spinner size={50} />
                        </div>
                    ) : (
                        <div className="row g-4 overflow-y gap-2" style={{ maxHeight: '400px' }}>
                            {filteredRows.length > 0 ? filteredRows.map((row, index) => (
                                <div className="d-flex flex-wrap" key={row.id || index}>
                                    <FormGroup id={`name-${index}`} label={'Nome'} className='col-md-3'>
                                        <Input disabled value={row.name} />
                                    </FormGroup>
                                    <FormGroup id={`unit-${index}`} label={'UN'} className='col-md-1'>
                                        <Input disabled value={row.unit} />
                                    </FormGroup>
                                    <FormGroup id={`exit-${index}`} label={'Saída Aut.'} className='col-md-2'>
                                        <Input disabled value={MultiplierPerMlOrKgCMV(row?.qtdExitAutomatic, row.unit)} />
                                    </FormGroup>
                                    <FormGroup id={`qtd-${index}`} label={'Quantidade'} className='col-md-2'>
                                        <Input
                                            type={'number'}
                                            onChange={(e) => handleInsumeQtds(row, e.target.value)}
                                            value={row?.newQtd}
                                        />
                                    </FormGroup>
                                    <FormGroup id={`loss-${index}`} label={'Perda'} className='col-md-2'>
                                        <Input
                                            type={'number'}
                                            onChange={(e) => handleInsumeLoss(row, e.target.value)}
                                            value={row?.newLoss}
                                        />
                                    </FormGroup>
                                    <FormGroup id={`promotial-${index}`} label={'Cortesia'} className='col-md-2'>
                                        <Input
                                            type={'number'}
                                            onChange={(e) => handleInsumePromotial(row, e.target.value)}
                                            value={row?.newPromotial}
                                        />
                                    </FormGroup>
                                </div>
                            )) : (
                                <p className="text-center">Nenhum insumo encontrado para a data selecionada.</p>
                            )}
                        </div>
                    )}
                </CardBody>

                <div className="row pb-4 pe-3">
                    <div className="d-flex justify-content-end gap-2">
                        <Button
                            color="danger"
                            icon="cancel"
                            onClick={handleOpen}
                        >
                            Cancelar
                        </Button>
                        {isLoading ? (
                            <BtnLoad />
                        ) : (
                            <Button
                                isDisable={rows.length === 0}
                                type="submit"
                                color="success"
                                icon="check"
                                onClick={onSucess}
                            >
                                Salvar
                            </Button>
                        )}
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ModalSaidaInsumo;
